import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import PostCard from 'components/shared/post-card';

const RelatedPostCardList = ({ items, className }) => (
  <section className={clsx('container pt-20 xl:pt-16 md:pt-14', className)}>
    <h2 className="text-4xl font-bold leading-tight">Watch more</h2>
    <div className="grid-gap mt-12 grid grid-cols-12 xl:mt-8 lg:mt-7 md:mt-5 md:block md:space-y-10">
      {items.map((item, index) => (
        <PostCard {...item} key={index} className="col-span-4 lg:col-span-6" />
      ))}
    </div>
  </section>
);

RelatedPostCardList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      cover: PropTypes.shape({
        localFile: PropTypes.shape({
          childImageSharp: PropTypes.shape({
            gatsbyImageData: PropTypes.any.isRequired,
          }).isRequired,
        }).isRequired,
        altText: PropTypes.string,
      }),
      videoType: PropTypes.string,
      videoId: PropTypes.string,
      category: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      date: PropTypes.string,
      publishedAt: PropTypes.string,
      place: PropTypes.string,
    })
  ),
  className: PropTypes.string,
};

RelatedPostCardList.defaultProps = {
  items: [],
  className: null,
};

export default RelatedPostCardList;
